export const environment = {
    production: false,
    apiUrl: 'https://voice.sdi.es',
    testing: false
};
